// IP-based country detection for currency selection.
// Returns a country code that exists in country.json; falls back to 'US'.

const SUPPORTED = ['TW', 'HK', 'MO', 'SG', 'MY', 'AU', 'US', 'CA']
const CACHE_KEY = 'ipastbook:ipCountry'

function timeoutSignal (ms) {
  if (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) {
    return AbortSignal.timeout(ms)
  }
  if (typeof AbortController !== 'undefined') {
    const ctrl = new AbortController()
    setTimeout(() => ctrl.abort(), ms)
    return ctrl.signal
  }
  return undefined
}

export async function detectCountryByIp () {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY)
    if (cached) return cached
  } catch (e) { /* sessionStorage 不可用 */ }

  const sources = [
    'https://get.geojs.io/v1/ip/country.json',
    'https://api.country.is/'
  ]
  for (const url of sources) {
    try {
      const res = await fetch(url, { signal: timeoutSignal(2500) })
      if (!res.ok) continue
      const json = await res.json()
      const cc = String(json.country || json.country_code || '').toUpperCase()
      if (cc) {
        const final = SUPPORTED.indexOf(cc) >= 0 ? cc : 'US'
        try { sessionStorage.setItem(CACHE_KEY, final) } catch (e) {}
        return final
      }
    } catch (e) { /* 尝试下一个 */ }
  }
  return 'US'
}
